import config from '../../config'
import { authHeader } from '../utils/auth-header'
import { playerService } from './player'
import { fixtureTeamService } from './fixtureteam'

export const teamService = {
  getAll,
  getOne,
  insertOne,
  linkTeamAndCompetitions,
  unlinkTeamAndCompetitions,
  updateOne,
  deleteOne,
  getOneGraph
}

async function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/team?_limit=1000&_sort=name:ASC`, requestOptions)
  result = await result.json()

  return { data: {teams: result} }
}

async function getOne (id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  // let result = await fetch(`${config.apiUrl}/graphql?query={ team(id:"${id}"){ name, _id, teamCompetitions{ _id, competition{_id, name} overrides } players{ first_name, last_name, usual_name, number, previous_yellow_cards, _id, position{ name, _id }, sport{ name, _id } } } }`, requestOptions)
  let result = await fetch(`${config.apiUrl}/team/${id}`, requestOptions)
  let formatted = { data: { team: await result.json() } }

  return formatted
}

async function getOneGraph (id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/graphql?query={ team(id:"${id}"){ name, _id, fixtureteams{_id} teamCompetitions{ _id, competition{_id, name} overrides } players{ first_name, last_name, usual_name, number, previous_yellow_cards, _id, position{ name, _id }, sport{ name, _id } } } }`, requestOptions)
  result = await result.json()
  return result
}

async function insertOne (team) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(team)
  }

  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/team`, requestOptions)

  result = await result.json()

  return result
}

async function linkTeamAndCompetitions (teamId, competitions) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader()
  }

  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  for (let competition of competitions) {
    requestOptions.body = JSON.stringify({ competition: competition._id, team: teamId, overrides: JSON.parse(competition.overrides) })
    await fetch(`${config.apiUrl}/teamcompetition`, requestOptions)
  }

  return 'OK'
}

async function updateOne (team) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(team)
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/team/${team._id}`, requestOptions)
  result = await result.json()

  return result
}

async function unlinkTeamAndCompetitions (teamCompetitionIds) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  for (let teamCompetitionId of teamCompetitionIds) {
    await fetch(`${config.apiUrl}/teamcompetition/${teamCompetitionId}`, requestOptions)
  }

  return 'OK'
}

async function deleteOne (teamId, playerIds, teamCompetitionIds, fixtureTeamIds) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  await fetch(`${config.apiUrl}/team/${teamId}`, requestOptions)
  await playerService.deleteMany(playerIds)
  await unlinkTeamAndCompetitions(teamCompetitionIds)
  await fixtureTeamService.deleteMany(fixtureTeamIds)

  return 'OK'
}



// WEBPACK FOOTER //
// ./src/services/team.js